/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Completedat1Inputs */

const zh_learn_completedat1 = /** @type {(inputs: Learn_Completedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成于`)
};

const en_learn_completedat1 = /** @type {(inputs: Learn_Completedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

const es_learn_completedat1 = /** @type {(inputs: Learn_Completedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizado`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Learn_Completedat1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_completedat1 = /** @type {((inputs?: Learn_Completedat1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Completedat1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_completedat1(inputs)
	if (locale === "en") return en_learn_completedat1(inputs)
	return es_learn_completedat1(inputs)
});
export { learn_completedat1 as "learn_completedAt" }